<div class="" style="height: 100%">
  <div
    class="col-md-12"
    class="modal-content"
    style="border-radius: 6px 6px 0 0 !important; height: 100%"
  >
    <div
      class="modal-header headerModal"
      style="text-align: center"
      *ngIf="!introData['trial_expiry']"
    >
      <button type="button" class="close" (click)="onCancel()">&times;</button>
    </div>
    <div
      style="
        padding: 2%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
      "
    >
      <div>
        <div style="text-align: center; padding: 1% 2% 3% 2%">
          <span *ngIf="!introData['trial_expiry']" style="font-size: 18px">{{
            'selfIntro.channel_message' | translate
          }}</span>
          <span
            *ngIf="introData['trial_expiry']"
            style="font-size: 18px; line-height: 1.4"
            >{{ 'selfIntro.trial_expire_msg' | translate }}</span
          >
        </div>
        <br />
        <div class="auth-block-body" style="height: 85px; width: auto">
          <div class="login-input submit" style="padding: 2%">
            <div
              class="login-submit"
              style="padding: 0; margin: 0; height: auto; border-radius: 5px"
            >
              <button
                *ngIf="!introData['trial_expiry']"
                id="addChannel"
                class="btn-auth commonButton"
                type="button"
                (click)="onSubmit(false)"
              >
                {{ 'selfIntro.addChannel' | translate }}
              </button>
              <button
                *ngIf="introData['trial_expiry']"
                id="subscribe"
                class="btn-auth commonButton"
                type="button"
                (click)="onSubmit(true)"
                style="margin-right: 15px"
              >
                {{ 'selfIntro.subscribe' | translate }}
              </button>
              <button
                *ngIf="introData['trial_expiry']"
                id="logout"
                class="btn-auth commonButton"
                type="button"
                (click)="logoutAccount()"
              >
                {{ 'selfIntro.logout' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
